import request from '@/utils/request';
const shortAPi = {
  // 创建推广位
  create(params: any) {
    return request.post('/baseConfig/shortUrl/generate', params);
  },
};

export default shortAPi;
